      <template>
  <form :id="formId+oamTypeCode">
    <div class="row h-row-inputBox">
      <div class="col-sm-6 h-col-inputBox">
        <div>
          <div class="h-inputLit">
            <span class="h-red-code">*</span>别名:
          </div>
          <input
            type="text"
            :class="['e-control', 'e-textbox', 'e-lib', 'e-input']"
            v-model="alias"
            placeholder="别名"
            name="aliasCheck"
          />
        </div>
      </div>
      <div class="col-sm-6 h-col-inputBox">
        <div>
          <div class="h-inputLit">描述:</div>
          <input
            type="text"
            :class="['e-control', 'e-textbox', 'e-lib', 'e-input']"
            v-model="description"
            placeholder="描述"
            name="descriptionCheck"
          />
        </div>
      </div>
    </div>
  </form>
</template>
<script>
import { EventBus } from "../../../plugins/eventBus";
import { FormValidator } from "@syncfusion/ej2-vue-inputs";

export default {
  name: "deployImsInput",
  components: {},
  props: ["oamTypeCode"],
  data() {
    return {
      formId: "deployCaseFormNsmf",
      oamType: "",
      alias: "",
      description: "",
      // formObj: "",
      validationOption: {
        customPlacement(inputElement, errorElement) {
          errorElement.style.float = "left";
          inputElement.parentElement.parentElement.appendChild(errorElement);
        },
        rules: {
          aliasCheck: {
            required: [true, `${this.$t("Pm.alertRequired")}`],
            regex: [/^(^\S)/, `${this.$t("Topo.noEmptyStart")}`],
            maxLength: [30, `${this.$t("Topo.topoMaxLength")}30`]
          },
          descriptionCheck: {
            regex: [/^(^\S)/, `${this.$t("Topo.noEmptyStart")}`],
            maxLength: [30, `${this.$t("Topo.topoMaxLength")}30`]
          }
        }
      }
    };
  },
  methods: {
    clear() {
      this.description = "";
      this.alias = "";
    },
    getDeployCaseInput() {
      if (this.oamType != 41) {
        //upf不需要校验此步骤
        if (!this.validate()) {
          return false;
        }
      }
      return {
        alias: this.alias,
        description: this.description
      };
    },
    init(oamType) {
      this.oamType = oamType;
      try {
        this.bindValidate();
      } catch (e) {
        console.log(e);
      }
    },
    bindValidate() {
      this.formObj = new FormValidator(
        "#deployCaseFormNsmf" + this.oamType,
        this.validationOption
      );
    },
    validate() {
      const formStatus = this.formObj.validate();
      return formStatus;
    }
  },
  mounted() {
    this.bindValidate();
  }
};
</script>
